import React from 'react'
import { Company } from 'models'
import { useCompaniesProviderState } from './companies/hooks/useCompaniesProviderState'
import type { CompaniesContextValue } from './companies/types'
import { MAX_SELECTED_CHILDREN } from './companies/constants'
import type { SelectionState } from './companies/helpers/selection'

const noop = () => {}
const defaultSelectionState: SelectionState = { mode: 'none', items: [] }

const defaultCompaniesContext: CompaniesContextValue = {
  parentCompanies: [],
  orphanCompanies: [],
  childrenCompanies: [],
  selectedParent: null,
  filteringCompaniesIds: [],
  isAllAccountsSelected: false,
  isOrphanSelected: false,
  pendingAllAccountsSelection: false,
  hasPendingSelection: false,
  pendingSelectionLimit: MAX_SELECTED_CHILDREN,
  pendingSelectionLimitReached: false,
  canSelectAllChildren: false,
  pendingSelectionState: defaultSelectionState,
  validatedSelectionState: defaultSelectionState,
  parentSearchValue: '',
  setParentSearchValue: noop,
  setParentSearchFilterValue: noop,
  childrenSearchValue: '',
  setChildrenSearchValue: noop,
  setChildrenSearchFilterValue: noop,
  isParentsFetching: false,
  setSelectedParent: noop as (entity: Company | null) => void,
  setPendingSelection: noop as (
    entities: Array<Company>,
    options?: { isAllAccountsSelected?: boolean },
  ) => void,
  validateSelection: noop,
  isB2CNoFamily: false,
  isError: false,
  isLoading: false,
  isChildrenLoading: false,
}

const CompaniesContext = React.createContext<CompaniesContextValue>(defaultCompaniesContext)

const CompaniesProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useCompaniesProviderState()
  return <CompaniesContext.Provider value={value}>{children}</CompaniesContext.Provider>
}

const useCompanies = () => React.useContext(CompaniesContext)

export type { SelectionState }
export { CompaniesProvider, useCompanies }
export { ALL_ACCOUNTS_ID, MAX_SELECTED_CHILDREN } from './companies/constants'
